import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  AfterViewInit
} from '@angular/core';
import { TrackingPageOrderItemsFrame } from '../../tracking-page.model';
import { OrderShipmentItem } from 'app/tracking-page/store/tracking-page-numbers';

@Component({
  selector: 'app-tracking-page-order-items-frame',
  templateUrl: './tracking-page-order-items-frame.component.html',
  styleUrls: ['./tracking-page-order-items-frame.component.scss']
})
export class TrackingPageOrderItemsFrameComponent implements AfterViewInit {
  @Input() itemsFrame: TrackingPageOrderItemsFrame;
  @Input() items: OrderShipmentItem[];
  @Input() itemsOpened = false;
  @Input() selectedId: any;
  @Output() selectBlock = new EventEmitter();
  @ViewChild('orderItemContainer') orderItemContainer: ElementRef;
  public orderItemHeight = 0;
  constructor() {}

  get showProductsButtonStyles() {
    const { borderRadius, borderWidth, borderColor, backgroundColor, shadow } =
      this.itemsFrame.button;
    return {
      'borderRadius.px': borderRadius,
      'borderWidth.px': borderWidth,
      borderColor,
      backgroundColor,
      boxShadow: shadow
    };
  }

  selectFrameButton(id: string, event: any) {
    event.stopPropagation();
    this.itemsOpened = !this.itemsOpened;
    this.selectBlock.emit(id);
  }

  selectFrameItem(id: string, event: any) {
    event.stopPropagation();
    this.selectBlock.emit(id);
  }

  getScrollHeight() {
    let heightSum = 0;
    const orderItems = this.orderItemContainer.nativeElement.children;
    for (let i = 0; i < this.itemsFrame.itemsLimit; i++) {
      heightSum += orderItems[i]?.offsetHeight || 0 + 26;
    }
    this.orderItemHeight = heightSum;
  }

  ngAfterViewInit(): void {
    if (this.itemsFrame?.scroll) {
      this.getScrollHeight();
    }
  }
}
